import * as React from "react";
import type { SVGProps } from "react";
const SvgExclamationInTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 15.96a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1ZM12 18.96a.84.84 0 0 1-.38-.08 1 1 0 0 1-.33-.21 1.15 1.15 0 0 1-.21-.33 1.001 1.001 0 0 1-.08-.38 1.23 1.23 0 0 1 0-.19c.01-.066.03-.13.06-.19a.561.561 0 0 1 .09-.17c.035-.057.075-.11.12-.16.095-.091.207-.162.33-.21a1 1 0 0 1 1.09.21c.045.05.085.103.12.16.04.051.07.109.09.17.03.06.05.124.06.19.023.06.037.125.04.19a.84.84 0 0 1-.08.38 1.15 1.15 0 0 1-.21.33 1.05 1.05 0 0 1-.71.29Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.505 21.829A1 1 0 0 0 2 21.96h20a1 1 0 0 0 .88-.49 1 1 0 0 0 0-1l-10-18a1 1 0 0 0-1.74 0l-10 18a1 1 0 0 0 0 1 1 1 0 0 0 .365.359ZM12 5.02l8.3 14.94H3.7L12 5.02Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExclamationInTriangle;
